import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { H2 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { RatingDisplay } from '@/components/RatingDisplay/RatingDisplay';

type Props = {
    completedReview: any;
};

export const ReviewedPageRatings = ({ completedReview }: Props) => {
    const reviewFieldClassName = cn('mb-xl max-w-[580px]');

    return (
        <section>
            <div className={reviewFieldClassName}>
                <H2 className="mb-2xs">
                    <FormattedMessage id="review_page.fields.accuracy" />
                </H2>
                <RatingDisplay rating={completedReview.accuracy} />
            </div>
            <div className={reviewFieldClassName}>
                <H2 className="mb-2xs">
                    <FormattedMessage id="review_page.fields.responsiveness" />
                </H2>
                <RatingDisplay rating={completedReview.responsiveness} />
            </div>
            <div className={reviewFieldClassName}>
                <H2 className="mb-2xs">
                    <FormattedMessage id="review_page.fields.payment" />
                </H2>
                <RatingDisplay rating={completedReview.payment} />
            </div>
            <div className={reviewFieldClassName}>
                <H2 className="mb-2xs">
                    <FormattedMessage id="review_page.fields.shipping" />
                </H2>
                <RatingDisplay rating={completedReview.shipping} />
            </div>
            <div className={reviewFieldClassName}>
                <H2 className="mb-2xs">
                    <FormattedMessage id="review_page.fields.overall" />
                </H2>
                <RatingDisplay rating={completedReview.overall} />
            </div>
        </section>
    );
};
